export default __webpack_public_path__ + "static/media/EM1450.34I-37417_-22062_0.ab11ecf6.jpg";